module.exports = __webpack_public_path__ + "img/Nav-btn.1620f25b.svg";